// Accessible tablist (SPEC §8.5): roving tabindex, arrow keys, Home/End.
import { useRef } from 'preact/hooks';

export function Tabs<K extends string>({ items, value, onChange, label, idBase }: {
  items: { key: K; label: string }[]; value: K; onChange: (k: K) => void; label: string; idBase: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const focus = (i: number) => {
    const n = items.length, k = items[(i + n) % n].key;
    onChange(k);
    queueMicrotask(() => ref.current?.querySelector<HTMLButtonElement>(`[data-k="${CSS.escape(k)}"]`)?.focus());
  };
  return (
    <div class="tabs no-print" role="tablist" aria-label={label} ref={ref}>
      {items.map((it, i) => (
        <button
          key={it.key} role="tab" type="button" data-k={it.key}
          id={`${idBase}-tab-${i}`} aria-controls={`${idBase}-panel`}
          aria-selected={it.key === value} tabIndex={it.key === value ? 0 : -1}
          onClick={() => onChange(it.key)}
          onKeyDown={(e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); focus(i + 1); }
            else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); focus(i - 1); }
            else if (e.key === 'Home') { e.preventDefault(); focus(0); }
            else if (e.key === 'End') { e.preventDefault(); focus(items.length - 1); }
          }}
        >{it.label}</button>
      ))}
    </div>
  );
}
